import { Box } from '@mui/material';

interface Props {
  size: string;
}

export function EmptyCircularFallbackImage({ size }: Props) {
  return (
    <Box height={size} width={size} border="2px solid" borderColor="grey.400" borderRadius="50%" />
  );
}
